import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Collapse from '@material-ui/core/Collapse'

import { supportsLocalStorage } from '../routing/hooks/useRouting'
import { getRegions } from '../app/selectors'
import { getKeyMetricIds } from '../app/selectors/metrics'
import { useActiveView, useCurtain, useMetric, useRegion } from '../app/hooks'
import { SelectMenu } from '../../../shared/components'
import { CurtainLoader } from './CurtainLoader'

const viewOptions = ['map', 'chart']
const regionOptions = getRegions().map(r => r.id)
const metricOptions = getKeyMetricIds()

const useStyles = makeStyles(() => ({
	root: {
		height: '100%',
		maxWidth: 580,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		textAlign: 'left',
		'& > div': {
			marginTop: 'auto',
			marginBottom: 'auto',
		}	
	},
	filter: {
		fontSize: 14,
		lineHeight: 1.5,
		marginBottom: 32,
		'& > button': {
			fontWeight: 'bold',
			fontSize: 'inherit',
			lineHeight: 'inhreit',
			verticalAlign: 'inherit',
			textDecoration: 'none',
			marginRight: '0.25em'
		},
		'& .MuiButtonBase-root': {
			textTransform: 'lowercase'
		},
	},
	go: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	goButton: {
		color: '#FFF',
		backgroundColor: '#FF003E',
		marginRight: 16
	},
	checkbox: {
		marginLeft: -2,
		'& .MuiButtonBase-root': {
			padding: 0,
			'&.Mui-checked': {
				'& .MuiSvgIcon-root': {
					color: '#031232',
				}
			}
		},
		'& .MuiSvgIcon-root': {
			color: '#DCDCDC'
		},
		'& .MuiCheckbox-label': {
			fontSize: 12
		}
	}
}))

export const CurtainFilters = ({ loading = true }) => {
	const classes = useStyles()
	const [activeView, setActiveView] = useActiveView()
	const [metric, setMetric] = useMetric()
	const [region, setRegion] = useRegion()
	const { skipCurtain, setShowCurtain } = useCurtain()
	const [showFilters, setShowFilters] = useState(false)

	const onGoClick = () => {
		if(skipCurtain && supportsLocalStorage) {
			localStorage.setItem('seda-opportunity-disable-curtain', true)
		}
		setShowCurtain(false)
	}

	useEffect(() => {
		setTimeout(() =>
			setShowFilters(true)
		, 300)
	}, [])

	return (
		<div>
			<Collapse
				in={showFilters}
				timeout={500}
			>
				<div>
					<div className="section__subtitle">
						What would you like to explore?
					</div>
					<div className={classes.filter}>
						<span>View a&nbsp;</span>
						<SelectMenu
							value={activeView}
							items={viewOptions}
							onSelect={setActiveView}
							className={classes.menu}
							MenuProps={{
								disablePortal: true
							}}
						/>
						<span>of&nbsp;</span>
						<SelectMenu
							value={metric}
							items={metricOptions}
							onSelect={setMetric}
							className={classes.menu}
							MenuProps={{
								disablePortal: true
							}}
						/>
						<span>for&nbsp;</span>
						<SelectMenu
							value={region}
							items={regionOptions}
							onSelect={setRegion}
							className={classes.menu}
							MenuProps={{
								disablePortal: true
							}}
						/>
					</div>
				</div>
			</Collapse>
			<div className={classes.go}>
				<Button
					variant='contained'
					className={classes.goButton}
					disabled={loading}
					onClick={onGoClick}
				>
					Go
				</Button>
				<CurtainLoader
					loading={loading}
				/>
			</div>
		</div>
	)
}